import { JobsSearch } from "@/components/jobs/JobsSearch";
import { useJobsFilter } from "@/contexts/JobsFilterContext";

interface JobsFilterWrapperProps {
  allSkills: string[];
  allStatuses: string[];
}

export const JobsFilterWrapper = ({
  allSkills,
  allStatuses
}: JobsFilterWrapperProps) => {
  const {
    searchTerm,
    setSearchTerm,
    skillsFilter,
    setSkillsFilter,
    skillsOperator,
    setSkillsOperator,
    statusFilter,
    setStatusFilter,
    showClosed,
    setShowClosed,
    maxDaysAgo,
    setMaxDaysAgo,
    showFavoritesOnly,
    setShowFavoritesOnly,
    viewMode,
    currentPage,
    setCurrentPage
  } = useJobsFilter();

  // Reset to first page when filters change
  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handleSkillsFilterChange = (skills: string[]) => {
    setSkillsFilter(skills);
    setCurrentPage(1);
  };

  const handleSkillsOperatorChange = (operator: "AND" | "OR") => {
    setSkillsOperator(operator);
    setCurrentPage(1);
  };

  const handleStatusFilterChange = (statuses: string[]) => {
    setStatusFilter(statuses);
    setCurrentPage(1);
  };

  const handleShowClosedChange = (show: boolean) => {
    setShowClosed(show);
    setCurrentPage(1);
  };

  const handleMaxDaysAgoChange = (days: number | null) => {
    setMaxDaysAgo(days);
    setCurrentPage(1);
  };
  const handleShowFavoritesOnlyChange = (show: boolean) => {
    setShowFavoritesOnly(show);
    setCurrentPage(1);
  };
  return (
    <JobsSearch 
      searchTerm={searchTerm}
      setSearchTerm={handleSearchTermChange}
      skillsFilter={skillsFilter}
      setSkillsFilter={handleSkillsFilterChange}
      skillsOperator={skillsOperator}
      setSkillsOperator={handleSkillsOperatorChange}
      statusFilter={statusFilter}
      setStatusFilter={handleStatusFilterChange}
      showClosed={showClosed}
      setShowClosed={handleShowClosedChange}
      maxDaysAgo={maxDaysAgo}
      setMaxDaysAgo={handleMaxDaysAgoChange}
      showFavoritesOnly={showFavoritesOnly}
      setShowFavoritesOnly={handleShowFavoritesOnlyChange}
      allSkills={allSkills}
      allStatuses={allStatuses}
      viewMode={viewMode}
    />
  );
};
